import { Phone, Mail, MapPin, Heart } from 'lucide-react';
import { Link } from 'react-router-dom';
import { contactInfo, navLinks } from '../../data/mock';

export const Footer = ({ onBookNow }) => {
  const handleNavClick = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const policyLinks = [
    { label: 'Privacy Policy', to: '/privacy-policy' },
    { label: 'Terms of Service', to: '/terms-of-service' },
    { label: 'Refund Policy', to: '/refund-policy' },
  ];

  return (
    <footer className="bg-obsidian">
      {/* CTA Band */}
      <div className="relative overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://images.unsplash.com/photo-1768468105374-08185b172342?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxjb3VwbGUlMjBvdXRkb29yJTIwcm9tYW50aWMlMjBldmVuaW5nfGVufDB8fHx8MTc3MDM1OTAyOXww&ixlib=rb-4.1.0&q=85"
            alt="Romantic evening"
            className="w-full h-full object-cover" />

          <div className="absolute inset-0 bg-obsidian/90" />
          <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_rgba(200,149,109,0.04)_0%,_transparent_60%)]" />
        </div>

        <div className="relative max-w-3xl mx-auto text-center py-20 md:py-28 px-6">
          <h2 className="font-heading md:text-[3.5rem] lg:text-[4rem] !font-light !leading-[3.72rem] !tracking-[-0.05em] mb-5 text-[2.5rem] text-ivory">
            Ready to Create
            <br />
            a <em className="italic text-amber">Memory</em>?
          </h2>
          <p className="font-body max-w-md !font-light mx-auto mb-10 text-[14px] text-ivory/25">Reserve your drive-in movie experience and let the stars write your story.

          </p>
          <button
            onClick={onBookNow}
            className="btn-shimmer font-body text-[13px] font-medium tracking-[0.15em] uppercase px-12 py-4 bg-amber/90 text-obsidian rounded-full hover:bg-amber transition-all duration-400 hover:shadow-[0_8px_40px_rgba(200,149,109,0.2)]">

            Reserve Your Evening
          </button>
        </div>
      </div>

      {/* Footer Content */}
      <div className="border-t border-amber/[0.05]">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-16">
          <div className="grid md:grid-cols-3 gap-12 md:gap-16">
            {/* Brand */}
            <div>
              <div className="mb-6">
                <img
                  src="https://customer-assets.emergentagent.com/job_outdoor-movie-date/artifacts/hmr7r529_TCE%20logo.webp"
                  alt="The Curated Experience"
                  className="h-12 w-auto"
                />
              </div>
              <p className="font-body text-[13px] text-ivory/20 leading-[1.8] font-light">
                Curated outdoor experiences that create memories lasting a lifetime.
                Cinema under the stars, beside hills and waterfall.
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="font-body text-[11px] tracking-[0.3em] uppercase text-ivory/30 mb-6">
                Navigate
              </h4>
              <div className="space-y-3.5">
                {navLinks.map((link) =>
                <button
                  key={link.href}
                  onClick={() => handleNavClick(link.href)}
                  className="block font-body text-[13px] text-ivory/20 hover:text-amber/60 transition-colors duration-400 font-light">

                    {link.label}
                  </button>
                )}
              </div>
            </div>

            {/* Contact */}
            <div>
              <h4 className="font-body text-[11px] tracking-[0.3em] uppercase text-ivory/30 mb-6">
                Get in Touch
              </h4>
              <div className="space-y-4">
                <a
                  href={`tel:${contactInfo.phone.replace(/\s/g, '')}`}
                  className="flex items-center gap-3.5 font-body text-[13px] text-ivory/20 hover:text-amber/60 transition-colors duration-400 font-light">

                  <Phone size={13} className="text-amber/30" />
                  {contactInfo.phone}
                </a>
                <a
                  href={`mailto:${contactInfo.email}`}
                  className="flex items-center gap-3.5 font-body text-[13px] text-ivory/20 hover:text-amber/60 transition-colors duration-400 font-light">

                  <Mail size={13} className="text-amber/30" />
                  {contactInfo.email}
                </a>
                <div className="flex items-start font-body !font-light gap-3.5 text-[13px] text-ivory/20">
                  <MapPin size={13} className="text-amber/30 mt-0.5 shrink-0" />
                  {contactInfo.location}
                </div>
              </div>
            </div>
          </div>

          {/* Bottom bar */}
          <div className="border-t border-amber/[0.04] mt-14 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="font-body text-[11px] text-ivory/15 font-light">
              &copy; {new Date().getFullYear()} The Curated Experience. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              {policyLinks.map((link, index) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className="font-body text-[11px] text-ivory/20 hover:text-amber/60 transition-colors duration-300 font-light"
                >
                  {link.label}
                </Link>
              ))}
            </div>
            <p className="font-body text-[11px] text-ivory/15 font-light flex items-center gap-1.5">
              Crafted with <Heart size={9} className="text-amber/25" /> in Assam
            </p>
          </div>
        </div>
      </div>
    </footer>);

};